import React, {memo} from "react"
import {PasswordContainer} from "../../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../../components/SubMenu"
import iconTest from "../../../../../assets/images/icons/settings/log.png"
import {SettingsPageContainer} from "../../../../../components/Settings/SettingsPageContainer"
import "./index.scss"
export const TestMenuScreen = memo(function TestMenuScreen() {
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings/advanced-settings"}>
                <div className="content-divider">
                    <div className="sub-menu-content-divider">
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Renk Testi"}
                            path={"/settings/advanced-settings/test/color-test"}
                        />
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Dokunma Testi"}
                            path={"/settings/advanced-settings/test/touch-test"}
                        />
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Ses Testi"}
                            path={"/settings/advanced-settings/test/sound-test"}
                        />
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Parlaklık Testi"}
                            path={"/settings/advanced-settings/test/brightness-test"}
                        />
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Sistem Bilgisi"}
                            path={"/settings/advanced-settings/test/system-info"}
                        />
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Network"}
                            path={"/settings/advanced-settings/test/network"}
                        />
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
